function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99984 9.99996V13.3333C7.99984 13.3333 10.0198 12.9666 10.6665 12C11.3865 10.92 10.6665 8.66663 10.6665 8.66663M7.99984 9.99996C8.93098 9.64559 9.82432 9.19892 10.6665 8.66663M7.99984 9.99996L5.99984 7.99996M5.99984 7.99996C6.3546 7.07958 6.80131 6.19734 7.33317 5.36663C8.10996 4.12462 9.19159 3.10199 10.4752 2.39602C11.7588 1.69005 13.2016 1.32421 14.6665 1.3333C14.6665 3.14663 14.1465 6.3333 10.6665 8.66663M5.99984 7.99996H2.6665C2.6665 7.99996 3.03317 5.97996 3.99984 5.3333C5.07984 4.6133 7.33317 5.36663 7.33317 5.36663M2.99984 11C1.99984 11.84 1.6665 14.3333 1.6665 14.3333C1.6665 14.3333 4.15984 14 4.99984 13C5.47317 12.44 5.4665 11.58 4.93984 11.06C4.68071 10.8126 4.33937 10.6697 3.98132 10.6586C3.62328 10.6476 3.27375 10.7691 2.99984 11Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgBoost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.a12fd291.svg";
export { ForwardRef as ReactComponent };